import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { ConversationsTable } from "../table/components/conversations-table";

export const ConversationsTableView = memo(function ConversationsTableView() {
  return (
    <Flex dir="column" gap="md" p="lg">
      <Text fontSize="lg" fontWeight="semibold">
        Inbox
      </Text>
      <ConversationsTable />
    </Flex>
  );
});
